import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import Payment from "@mui/icons-material/Payment";
import Replay from "@mui/icons-material/Replay";
import { OnlinePaymentStatus } from "api";
import { PaymentCtaButton as BaseBtn } from "components";

export const PaymentCtaButton = ({
  paymentStatus,
}: {
  paymentStatus?: OnlinePaymentStatus;
}) => {
  const { t } = useTranslation();
  const params = useParams<{ guid?: string }>();
  const navigate = useNavigate();
  const paymentUrl = `/payment/${params.guid}`;

  switch (paymentStatus) {
    case OnlinePaymentStatus.NotStarted:
      return (
        <BaseBtn
          label={t("confirmation.payOnline")}
          onClick={() => navigate(paymentUrl)}
          countdown={30}
          startIcon={<Payment />}
        />
      );
    case OnlinePaymentStatus.Failed:
      return (
        <BaseBtn
          label={t("confirmation.retryPayment")}
          onClick={() => navigate(paymentUrl)}
          startIcon={<Replay />}
        />
      );
    case OnlinePaymentStatus.Abandoned:
      return (
        <BaseBtn
          label={t("confirmation.finishPayment")}
          onClick={() => navigate(paymentUrl)}
          startIcon={<Payment />}
        />
      );
    default:
      return null;
  }
};
